import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";
import Checkbox from "../HotListCheckbox";
import { can } from "../../access";

const SellerInfo = ({
  data,
  handleChangeInput,
  isExists,
  handleChangeDropdown,
  viewMode,
  deleted,
  toggleDrawer
}) => {
  return (
    <div className="Seller-info">
      <div className="Seller-info_column">
      {(isExists) && <p className="errorText"> Given Seller Details Already Exists</p>}
        <div className="hotlist_name_section">
          <div className="Buyer-info_column_hotlist_name_label">
              <label>First Name</label>
              <Checkbox 
                  text="Hot List"
                  type={viewMode || !can('peak.pipeline') ? "uncheckable" : "checkable"}
                  isSelected={data.HSC_HOT_LIST === "1"} 
                  handleClick={() => handleChangeInput("HSC_HOT_LIST")} 
                  name="HSC_HOT_LIST"
              />
  
          </div>
          <Input
              className="Buyer-info_column_item"
              required
              valueType="text"
              name="FIRST_NAME"
              value={data.FIRST_NAME}
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
          />
          </div>
       {/*  <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          name="FIRST_NAME"
          label="First Name"
          value={data.FIRST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          name="LAST_NAME"
          label="Last Name"
          value={data.LAST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="phone"
          name="PHONE"
          label="Phone"
          value={data.PHONE}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="email"
          name="EMAIL"
          label="Email"
          value={data.EMAIL}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Seller-info_column_item"
          data={data}
          optionsType="profiles"
          value={data.PROFILE}
          valueKey="PROFILE"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Textarea
          className="Seller-info_column_item"
          label="Notes"
          name="NOTES"
          value={data.NOTES}
          maxWidth="100%"
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
      <div className="Seller-info_column">
        <Dropdown
          className="Seller-info_column_item"
          data={data}
          optionsType="sellerStatus"
          value={data.STATUS}
          valueKey="STATUS"
          label="Seller Status"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />      
        <div className='Seller-info_last-modified'>Last modified on: {data.LAST_MODIFIED}</div>
        {data.STATUS &&
        <div className="Seller-info_button button-new positive" onClick={toggleDrawer}>Add Property</div>
        }
      </div>
    </div>
  );
};

export default SellerInfo;
